
import { GET_ROOMS, GET_MESSAGES, ACCESS_REQUEST } from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import {changeParamsToQuery} from './commonFn';

export class ChatService {

  static instance;
  static getInstance() {
    if (!ChatService.instance) {
      ChatService.instance = new ChatService();
    }
    return ChatService.instance;
  }

  fetchChatRooms = async (params) => {
    let newsResponse = await Api.get(`${GET_ROOMS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchChatMessages = async (params) => {
    let newsResponse = await Api.get(`${GET_MESSAGES.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  sendAccessRequest = async (params) => {
    let newsResponse = await Api.post(`${ACCESS_REQUEST.URL}`, params);
    return newsResponse;
  }

 




}

